import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { FormModule } from '../form/form.module';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { NavModule } from '../nav/nav.module';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { AppTooltipModule } from '../tooltip/tooltip.module';
import { PipesModule } from '../pipes/pipes.module';
import { DownloadItemModule } from '../download-item/download-item.module';
import { ShareLinkModule } from '../share-link/share-link.module';
import { CollapseModule } from '../collapse/collapse.module';
import { ScorecardModule } from '../scorecard/scorecard.module';
import { DetailsPageModule } from 'shared/details-page/details-page.module';

import { SearchService } from './search.service';
import { AdvancedSearchService } from './advanced-search/advanced-search.service';

import { SearchResultsComponent } from './search-results/search-results.component';
import { SearchResultsRowComponent } from './search-results/search-results-row/search-results-row.component';
import { ImageRendererModule } from '../image-renderer/image-renderer.module';
import { StatusRendererComponent } from './search-results/status-renderer/status-renderer.component';
import { TextRendererComponent } from './search-results/text-renderer/text-renderer.component';
import { BtnRendererComponent } from './search-results/btn-renderer/btn-renderer.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { SearchPreviewComponent } from './search-preview/search-preview.component';
import { BaseAdvancedSearchComponent } from './advanced-search/_base-advanced-search.component';
import { VehicleSearchComponent } from './vehicle-search/vehicle-search.component';
import { VehicleAttributesSearchComponent } from './vehicle-attributes-search/vehicle-attributes-search.component';
import { PartAttributesSearchComponent } from './part-attributes-search/part-attributes-search.component';
import { StateSearchComponent } from './state-search/state-search.component';
import { TagsSearchComponent } from './tags-search/tags-search.component';
import { ActiveFiltersComponent } from './active-filters/active-filters.component';
import { SortingPanelComponent } from './sorting-panel/sorting-panel.component';
import { StatusesPanelComponent } from './statuses-panel/statuses-panel.component';
import { SearchResultsEmptyStateComponent } from './search-results/search-results-empty-state/search-results-empty-state.component';
import { SelectOptionsComponent } from './select-options/select-options.component';

// SEARCH VERSION 2
import { SearchInputComponent } from './search-input/search-input.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TypeaheadModule.forRoot(),
    FormModule,
    IconModule,
    ButtonModule,
    DropdownModule,
    NavModule,
    ImageRendererModule,
    EmptyStateModule,
    SpinnerModule,
    AppTooltipModule,
    PipesModule,
    DownloadItemModule,
    ShareLinkModule,
    CollapseModule,
    ScorecardModule,
    DetailsPageModule,
  ],
  declarations: [
    SearchFormComponent,
    SearchResultsComponent,
    SearchResultsRowComponent,
    SearchPreviewComponent,
    ActiveFiltersComponent,
    StatusRendererComponent,
    TextRendererComponent,
    BtnRendererComponent,
    SortingPanelComponent,
    StatusesPanelComponent,
    BaseAdvancedSearchComponent,
    VehicleSearchComponent,
    VehicleAttributesSearchComponent,
    PartAttributesSearchComponent,
    StateSearchComponent,
    TagsSearchComponent,
    SearchResultsEmptyStateComponent,
    SelectOptionsComponent,
    SearchInputComponent,
  ],
  exports: [
    SearchFormComponent,
    SearchResultsComponent,
    SearchResultsRowComponent,
    SearchPreviewComponent,
    ActiveFiltersComponent,
    StatusRendererComponent,
    TextRendererComponent,
    BtnRendererComponent,
    SortingPanelComponent,
    StatusesPanelComponent,
    BaseAdvancedSearchComponent,
    VehicleSearchComponent,
    VehicleAttributesSearchComponent,
    PartAttributesSearchComponent,
    StateSearchComponent,
    TagsSearchComponent,
    SearchResultsEmptyStateComponent,
    SelectOptionsComponent,
    SearchInputComponent,
  ],
  providers: [SearchService, AdvancedSearchService]
})
export class SearchModule {}
